<template>
<div class="home-container">
    <div class="home" :class="{ 'left-collapsed': leftPanelCollapsed, 'right-collapsed': rightPanelCollapsed }">
    <Toolbar
      ref="toolbarRef"
      :projectName="projectName"
      :changeProjectName="changeProjectName"
      :isInitSave="isInitSave"
    />
    <!-- 可选择的组件 -->
    <div class="comp-panel">
      <ComponentList
        :allComponentList="allComponentList"
      />
    </div>
    <main>
      <!-- 左侧组件列表 -->
      <section class="left">
        <LeftComp
          ref="leftComp"
          :currentPage="currentPage"
          :pageOptions="pageOptions"
          @pageSelect="pageSelect"
          @deletePage="deletePage"
          @copyPage="copyPage"
          @addPage="addNewPage"
          @addChildPage="addChildPage"
          @sortPage="showSortDialog"
        ></LeftComp>
        <DragableSort ref="dragableSort" />
        <!-- <div class="pageSelector">
          <el-select
            v-model="currentPage"
            class="select"
            :placeholder="$tt('请选择')"
            size="medium"
            ref="pageSelector"
          >
            <el-option
              v-for="item in pageOptions"
              :key="item.value"
              :label="$tt(item.label)"
              :value="item.value"
              class="pageItem"
            >
              <span>
                {{ item.label }}
              </span>
              <span
                v-if="pageOptions.length > 1"
                class="el-icon-delete"
                @click="deletePage($event, item.value)"
              />
            </el-option>
          </el-select>
          <div class="sortBtn" @click="showSortDialog">排序</div>
        </div>
        <DragableSort ref="dragableSort" />
        <CurrentPageComponents :pageKey="currentPage" />
        <div class="addPageBtn" @click="addNewPage">添加新页面</div> -->
      </section>
      <!-- 中间画布 -->
      <section class="center">
        <button
          type="button"
          class="panel-fold panel-fold-left"
          :title="leftPanelCollapsed ? $tt('展开左侧 (Alt+1)') : $tt('收起左侧 (Alt+1)')"
          @click="leftPanelCollapsed = !leftPanelCollapsed"
        >
          <i :class="leftPanelCollapsed ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"></i>
        </button>
        <button
          type="button"
          class="panel-fold panel-fold-right"
          :title="rightPanelCollapsed ? $tt('展开右侧 (Alt+2)') : $tt('收起右侧 (Alt+2)')"
          @click="rightPanelCollapsed = !rightPanelCollapsed"
        >
          <i :class="rightPanelCollapsed ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"></i>
        </button>
        <div
          id="content"
          class="content"
          v-loading="pageSwitchLoading"
          :element-loading-text="$tt('页面加载中...')"
          element-loading-background="rgba(255, 255, 255, 0.65)"
          @drop="handleDrop"
          @dragover="handleDragOver"
          @contextmenu.capture.prevent="handleCanvasContextMenu"
          @mousedown="handleMouseDown"
          @mouseup="deselectCurComponent"
          @mouseleave="eidtorOnBlurHandler"
          @mouseenter="editorOnFocusHandler"
        >
          <div
            v-if="canvasErrorBanner"
            class="canvas-error-banner"
          >
            <i class="el-icon-warning" />
            <span>{{ canvasErrorBanner }}</span>
          </div>
          <Editor
            :isInitLoaded="isInitLoaded"
            :skipInitialLoading="isInitLoaded"
            ref="editorRef"
          />
          <!-- 右击菜单 -->
          <ContextMenu />
        </div>
      </section>
      <!-- 右侧属性列表 -->
      <section class="right">
        <el-tabs v-model="activeName">
          <el-tab-pane name="attr">
            <span slot="label">{{ $tt("基本属性") }}</span>
            <AttrList v-if="curComponent" />
            <p v-else class="placeholder">{{ $tt("请选择组件") }}</p>
          </el-tab-pane>

          <el-tab-pane
            name="networkConfig"
            v-if="isHasDirectivesAndEvents('networkConfig')"
          >
            <span slot="label">
              <AttrHelpDot help-key="tab.networkConfig" />{{ $tt("网络配置") }}
              <span v-if="tabNetworkCount" class="tab-bind-badge">{{ tabNetworkCount }}</span>
            </span>
            <NetworkConfig v-if="curComponent" />
            <p v-else class="placeholder">{{ $tt("请选择组件") }}</p>
          </el-tab-pane>

          <el-tab-pane
            name="events"
            v-if="isHasDirectivesAndEvents('events')"
          >
            <span slot="label">
              <AttrHelpDot help-key="tab.events" />{{ $tt("事件配置") }}
              <span v-if="tabEventCount" class="tab-bind-badge">{{ tabEventCount }}</span>
            </span>
            <EventsAttrs v-if="curComponent" />
            <p v-else class="placeholder">{{ $tt("请选择组件") }}</p>
          </el-tab-pane>

          <el-tab-pane
            name="activeDetectionConfig"
            v-if="isHasDirectivesAndEvents('activeDetectionConfig')"
          >
            <span slot="label"><AttrHelpDot help-key="tab.activeDetectionConfig" />{{ $tt("网络状态") }}</span>
            <ActiveDetectionConfig v-if="curComponent" />
            <p v-else class="placeholder">{{ $tt("请选择组件") }}</p>
          </el-tab-pane>

          <el-tab-pane
            name="passiveMonitorConfig"
            v-if="isHasDirectivesAndEvents('passiveMonitorConfig')"
          >
            <span slot="label"><AttrHelpDot help-key="tab.passiveMonitorConfig" />{{ $tt("开关状态") }}</span>
            <PassiveMonitorConfig v-if="curComponent" />
            <p v-else class="placeholder">{{ $tt("请选择组件") }}</p>
          </el-tab-pane>
        </el-tabs>
      </section>
    </main>
  </div>
  <el-dialog
      :visible.sync="loadChangeDialog"
      width="340px"
      custom-class="closeDialog"
      :before-close="loadChangeCancel"
    >
      <span>{{ $tt("检测到有未保存的变更，是否载入？") }} </span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="loadChangeCancel">{{ $tt("取 消") }}</el-button>
        <el-button size="small" type="primary" @click="loadChangeConfirm">
          {{ $tt("确 定") }}
        </el-button>
      </span>
    </el-dialog>
    <!-- AI 画布助手 -->
    <CanvasAiPanel ref="canvasAiPanel" :editor-hooks="canvasAiHooks" />
  <SmartToolbox :ai-enabled="canvasAiEnabled" @open-ai="openCanvasAi" />
</div>
</template>

<script>
import Editor from "@/components/Editor/index";
import ComponentList from "@/components/ComponentList"; // 左侧列表组件
import CurrentPageComponents from "@/components/CurrentPageComponents"; //选择页所使用的组件
import AttrList from "@/components/AttrList"; // 右侧属性列表
import AnimationList from "@/components/AnimationList"; // 右侧动画列表
import EventsAttrs from "@/components/EventsAttrs";
import NetworkConfig from "@/components/NetworkConfig"; // 右侧事件列表
import componentList, {
  matrixComponents,
} from "@/custom-component/component-list"; // 左侧列表数据
import DragableSort from "@/components/DragableSort.vue";
import Toolbar from "@/components/Toolbar";
import { deepCopy, getComponentsByType, uuid, isEmpty, clientPointToCanvas, setCookie } from "@/utils/utils";
import {
  flushCurrentPage,
  mergePageIntoCanvasAllData,
  normalizePageDataPayload,
  isPageSkeleton,
  parseCanvasAllData,
  compactCanvasMemory,
  collectBoundChildPageIds,
  clearCanvasSessionStorage,
  leaveCanvasEditor,
  stringifyCanvasAllData,
  stripLazySkeletonFromPage,
} from "@/utils/canvasPageLoader";
import { coalescedSetProjectCache } from "@/utils/canvasDraftWriter";
import { pruneCanvasErrorMap } from "@/utils/canvasValidation";
import { normalizeCanvasAllDataString } from "@/utils/canvasInitData";
import { BACK_COMPONENT, ATTRS_VALIDATE_MAP } from "@/utils/attrNameData";
import { mapState } from "vuex";
import generateID from "@/utils/generateID";
import { listenGlobalKeyDown, unlistenGlobalKeyDown } from "@/utils/shortcutKey";
import ContextMenu from '@/components/Editor/ContextMenu';
import eventBus from '@/utils/eventBus'
import { ECOLOGICAL_SIGN, ECOLOGICAL_CHILDREN_SIGN } from '@/constants/editor';
import {
  buildPlayerControlGroup,
  PLAYER_CONTROL_SIGN,
  PLAYER_CONTROL_BUTTON_COUNTS,
} from '@/constants/playerControlTemplates';
import createGroupStyle from '@/utils/createGroupStyle';
import ActiveDetectionConfig from '@/components/ActiveDetectionConfig';
import PassiveMonitorConfig from '@/components/PassiveMonitorConfig';
import AttrHelpDot from '@/components/AttrHelpDot';
import { networkBindCount, eventBindCount } from "@/utils/canvasBindSummary";
import LeftComp from "./components/leftComp";
import SmartToolbox from "@/components/SmartToolbox/index.vue";
import CanvasAiPanel from "./components/canvas-ai/CanvasAiPanel";
import { isSuperAdmin } from "@/utils/account";

import moment from "moment";
export default {
  components: {
    Editor,
    ComponentList,
    AttrList,
    AnimationList,
    EventsAttrs,
    NetworkConfig,
    Toolbar,
    CurrentPageComponents,
    DragableSort,
    ContextMenu,
    ActiveDetectionConfig,
    PassiveMonitorConfig,
    AttrHelpDot,
    LeftComp,
    SmartToolbox,
    CanvasAiPanel
  },
  data() {
    return {
      allComponentList: Object.assign([], componentList),
      activeName: "attr",
      reSelectAnimateIndex: undefined,
      page_sort: ['1'],
      currentPage: '1',
      currentPageParent: null,
      projectName: `模板-${moment().format("YYYY-MM-DD HH:mm")}`,
      addNewPageBtnDis: false,
      loadChangeDialog: false,
      panel_data: null,
      isInitSave: false,
      isInitLoaded: false,
      loadCacheData: null,
      initCanvasData: JSON.stringify({
        1: [BACK_COMPONENT()],
      }),
      copyCanvasDatas: null,
      /**
       * 快速连续切换页面时丢弃过期的 requestAnimationFrame。
       * 注意：Vue2 不会代理以 _/$ 开头的 data，勿用 _pageSwitchToken。
       */
      pageSwitchToken: 0,
      /** 避免切页时并发重复请求同一页 */
      pageLoadPromises: {},
      /** 同一页多次 findPage 时，只应用最后一次结果，避免过期响应盖掉正在编辑的页 */
      pageLoadGens: {},
      /** 切页拉取后端数据时的 loading */
      pageSwitchLoading: false,
      pendingLocateError: null,
      canvasErrorBanner: "",
      canvasErrorBannerTimer: null,
      /** 切页落库失败回滚时，避免 watcher 重复触发 */
      suppressPageSwitch: false,
      /** 右键菜单刚打开的时间戳，避免 mouseup 误关菜单 */
      contextMenuOpenedAt: 0,
      leftPanelCollapsed: false,
      rightPanelCollapsed: false,
      /** 画布缩放全工程共用 */
      globalCanvasScale: 1,
      /** 每页记住平移位置 { [pageId]: { left, top } } */
      pagePanMap: {},
      canvasAiEnabled: false,
      canvasAiHasModel: true,
      canvasAiNoModelMsg: "",
      pendingLocateViewport: false,
    };
  },
  watch: {
    async currentPage(key, oldKey) {
      if (this.suppressPageSwitch) {
        return;
      }
      this.pageSwitchToken += 1;
      const switchToken = this.pageSwitchToken;
      const switching =
        oldKey !== undefined &&
        oldKey !== null &&
        String(oldKey) !== String(key);

      // 切页前先把上一页编辑中的组件写回 canvasAllData（必须确认 componentData 仍属于 oldKey）
      if (switching) {
        this.flushCurrentPageToStore(oldKey);
      }

      this.$store.commit("clearSnap");
      this.$store.commit("setCanvasPageSwitching", true);

      try {
        // 懒加载：离开页先落库，再请求当前页并渲染（不再先把全部页驱逐成骨架，避免误写）
        if (this.canvasLazyLoad && switching) {
          this.pageSwitchLoading = true;
          try {
            const persisted = await this.persistPageIfNeeded(oldKey);
            if (!persisted) {
              this.$message.error("上一页保存失败，请重试后再切换页面");
              this.rollbackPageSwitch(oldKey, switchToken);
              return;
            }
            const loadedOk = await this.ensurePageLoaded(key);
            if (switchToken !== this.pageSwitchToken) {
              return;
            }
            if (!loadedOk && !this.isCanvasPageLoaded(key)) {
              this.$message.error("页面加载失败，请重试后再切换页面");
              this.rollbackPageSwitch(oldKey, switchToken);
              return;
            }
            const boundIds = await this.ensureBoundChildPagesForPage(key);
            if (switchToken !== this.pageSwitchToken) {
              return;
            }
            this.evictOtherPagesFromMemory([key, ...boundIds]);
          } catch (e) {
            console.error("ensurePageLoaded failed", e);
            this.$message.error("页面加载失败，请重试后再切换页面");
            this.rollbackPageSwitch(oldKey, switchToken);
            return;
          } finally {
            if (switchToken === this.pageSwitchToken) {
              this.pageSwitchLoading = false;
            }
          }
        } else {
          try {
            await this.ensurePageLoaded(key);
          } catch (e) {
            console.error("ensurePageLoaded failed", e);
          }
        }

        if (switchToken !== this.pageSwitchToken) {
          return;
        }

        if (switching) {
          const ed = this.$refs.editorRef;
          if (ed && typeof ed.getViewportState === "function") {
            this._carryViewport = ed.getViewportState();
            const scale = Number(this._carryViewport && this._carryViewport.scale);
            if (isFinite(scale) && scale > 0) {
              this.globalCanvasScale = scale;
            }
          }
        }

        const toolbar = this.$refs.toolbarRef;
        const wasClean = !!(
          toolbar &&
          typeof toolbar.isCanvasUnchanged === "function" &&
          toolbar.isCanvasUnchanged()
        );
        this.restore(key);
        if (wasClean && toolbar && typeof toolbar.capturePersistBaseline === "function") {
          this.schedulePersistBaseline();
        }
        // 须在 restore 之后：否则 curComponent 仍指向上一页画布中的对象，会导致主/子页面尺寸与选中态错乱
        if (
          this.pendingLocateError &&
          String(this.pendingLocateError.pageId) === String(key)
        ) {
          this.applyLocateErrorSelection();
        } else {
          this.$store.commit("setCurComponent", {
            component: this.componentData[0],
            index: 0,
          });
        }
        if (switching) {
          this.$nextTick(() => {
            this.$nextTick(() => {
              if (this.pendingLocateViewport) {
                this.pendingLocateViewport = false;
                this.locateCanvasViewport();
                requestAnimationFrame(() => {
                  this.locateCanvasViewport();
                });
              } else {
                this.applyViewportAfterPageSwitch(key, switchToken);
                requestAnimationFrame(() => {
                  this.applyViewportAfterPageSwitch(key, switchToken);
                });
              }
            });
          });
        }
      } finally {
        if (switchToken === this.pageSwitchToken) {
          this.$store.commit("setCanvasPageSwitching", false);
        }
      }
    },
    curComponent(newV) {
      this.activeName = "attr";
    },
    "$route.query": {
      handler(q, oldQ) {
        if (!oldQ) {
          return;
        }
        const nextKey = [q.id, q.temporaryId, q.isCommonTemplate].join(":");
        const prevKey = [oldQ.id, oldQ.temporaryId, oldQ.isCommonTemplate].join(":");
        // 模板「使用」首次保存后会换成正式工程 id，不能当新工程整页重载
        if (
          oldQ.isCommonTemplate &&
          !q.isCommonTemplate &&
          q.id &&
          oldQ.id &&
          String(q.id) !== String(oldQ.id)
        ) {
          return;
        }
        if (nextKey !== prevKey) {
          this.resetEditorForNewProject();
          this.setLocalData();
        }
      },
    },
  },
  computed: {
    ...mapState([
      "componentData",
      "curComponent",
      "isClickComponent",
      "canvasStyleData",
      "editor",
      "pageOptions",
      "selectedCurrentPage",
      "projectValidateMap",
      "loginAccountInfo",
      "canvasAllData",
      "cacheCanvasDataKey",
      "canvasLazyLoad",
      "canvasLoadedPageIds",
      "canvasServerButtonCount",
    ]),
    isHasDirectivesAndEvents() {
      return (type) => {
        let isEcoShow = type === 'networkConfig' ? this.curComponent && this.curComponent.compType !== ECOLOGICAL_CHILDREN_SIGN : true;
        return this.curComponent && isEcoShow && this.curComponent[type];
      };
    },
    tabNetworkCount() {
      return networkBindCount(this.curComponent);
    },
    tabEventCount() {
      return eventBindCount(this.curComponent);
    },
    canvasAiHooks() {
      const vm = this;
      return {
        getButtonCountEstimate: () => vm.getButtonCountEstimate(),
        getRouteLimits: () => {
          try {
            return (
              (atob(vm.$route.query.limits) &&
                JSON.parse(atob(vm.$route.query.limits))) ||
              {}
            );
          } catch (e) {
            return {};
          }
        },
        getCanvasStyle: () => {
          try {
            return JSON.parse(sessionStorage.getItem('canvasStyle')) || vm.$store.state.canvasStyleData;
          } catch (e) {
            return vm.$store.state.canvasStyleData;
          }
        },
        saveProject: () => {
          if (vm.$refs.toolbarRef && vm.$refs.toolbarRef.saveProject) {
            return vm.$refs.toolbarRef.saveProject();
          }
          return Promise.resolve(false);
        },
        getPageSnapshot: () => {
          try {
            return JSON.parse(JSON.stringify(vm.componentData || []));
          } catch (e) {
            return vm.componentData || [];
          }
        },
        getSnapshotMeta: () => ({
          projectId: vm.$route.query && vm.$route.query.id,
          pageId: String(vm.selectedCurrentPage),
        }),
        restorePageSnapshot: (pageArr) => {
          const key = vm.selectedCurrentPage;
          const list = Array.isArray(pageArr) ? pageArr : [];
          vm.$store.commit("setComponentData", list);
          vm.flushCurrentPageToStore(key);
        },
        openPreview: () => eventBus.$emit('preview'),
        locateCanvasError: (info) => vm.locateCanvasError(info),
        restoreAreaVisual: (ids) => {
          const idSet = {};
          (ids || []).forEach((id) => {
            idSet[String(id)] = true;
          });
          const list = (vm.$store.state.componentData || []).filter(
            (c) => c && idSet[String(c.id)]
          );
          if (vm.$refs.editorRef && vm.$refs.editorRef.applyComponentSelection) {
            vm.$refs.editorRef.applyComponentSelection(list);
          }
        },
        flushPage: () => vm.flushCurrentPageToStore(vm.selectedCurrentPage),
      };
    },
  },
  created() {
    eventBus.$on("inputValidate", this.inputValChange);
    eventBus.$on("ensureCanvasPages", this.onEnsureCanvasPages);
    eventBus.$on("locateCanvasError", this.locateCanvasError);
    eventBus.$on("persistAllLoadedPagesBeforeSave", this.onPersistAllLoadedPagesBeforeSave);
    eventBus.$on("locateCanvas", this.locateCanvasViewport);
    eventBus.$on("canvasAiAddToChat", this.onAddToAiChat);
    this.$store.commit("setCanvasEditorLeaving", false);
    this.setLocalData();
    this.getListComp();
  },
  mounted() {
    this.bindGlobalCanvasContextMenu();
    window.addEventListener("keydown", this.onPanelHotkey);
    document.addEventListener("visibilitychange", this.onCanvasAiVisibility);
    window.addEventListener("pageshow", this.onCanvasAiPageShow);
    this.fetchCanvasAiHealth();
  },
  activated() {
    this.fetchCanvasAiHealth();
    listenGlobalKeyDown();
  },
  deactivated() {
    unlistenGlobalKeyDown();
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onPanelHotkey);
    document.removeEventListener("visibilitychange", this.onCanvasAiVisibility);
    window.removeEventListener("pageshow", this.onCanvasAiPageShow);
    this.unbindGlobalCanvasContextMenu();
    eventBus.$off('inputValidate', this.inputValChange);
    eventBus.$off("ensureCanvasPages", this.onEnsureCanvasPages);
    eventBus.$off("locateCanvasError", this.locateCanvasError);
    eventBus.$off("persistAllLoadedPagesBeforeSave", this.onPersistAllLoadedPagesBeforeSave);
    eventBus.$off("locateCanvas", this.locateCanvasViewport);
    eventBus.$off("canvasAiAddToChat", this.onAddToAiChat);
    if (this._persistBaselineTimer) {
      clearTimeout(this._persistBaselineTimer);
      this._persistBaselineTimer = null;
    }
    if (this.canvasErrorBannerTimer) {
      clearTimeout(this.canvasErrorBannerTimer);
    }
    if (this.cacheCanvasDataKey) {
      this.$request.removeProjectCache(this.cacheCanvasDataKey).catch(() => {});
    }
    leaveCanvasEditor(this.$store);
    unlistenGlobalKeyDown();
  },
  methods: {
    onPanelHotkey(e) {
      if (!e || !e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) {
        return;
      }
      const code = e.code || "";
      const isAiToggle = code === "Digit3" || code === "Numpad3" || e.key === "3";
      const t = e.target;
      if (t && !isAiToggle) {
        const tag = (t.tagName || "").toLowerCase();
        if (tag === "input" || tag === "textarea" || tag === "select" || t.isContentEditable) {
          return;
        }
      }
      if (isAiToggle) {
        e.preventDefault();
        this.toggleCanvasAi();
        return;
      }
      if (code === "Digit1" || code === "Numpad1" || e.key === "1") {
        e.preventDefault();
        this.leftPanelCollapsed = !this.leftPanelCollapsed;
        return;
      }
      if (code === "Digit2" || code === "Numpad2" || e.key === "2") {
        e.preventDefault();
        this.rightPanelCollapsed = !this.rightPanelCollapsed;
      }
    },
    isCanvasAiAdminAccount() {
      const info = this.loginAccountInfo || {};
      return !!(info.is_manage || info.isManage || isSuperAdmin(info));
    },
    canvasAiFlagOn(v) {
      return v === true || v === 1 || v === "1" || v === "true";
    },
    pickCanvasAiHealth(res) {
      const list = [];
      if (res) list.push(res);
      const d = res && res.data;
      if (d) list.push(d);
      if (d && d.data) list.push(d.data);
      if (d && d.inner_map) list.push(d.inner_map);
      if (d && d.result && !Array.isArray(d.result)) list.push(d.result);
      for (let i = 0; i < list.length; i++) {
        const s = list[i];
        if (
          s &&
          typeof s === "object" &&
          (s.enabled != null ||
            s.has_model != null ||
            s.hasModel != null ||
            s.ai_visible != null ||
            s.aiVisible != null)
        ) {
          return s;
        }
      }
      return d || {};
    },
    applyCanvasAiHealth(res, persist) {
      const inner = this.pickCanvasAiHealth(res) || {};
      const admin = this.isCanvasAiAdminAccount();
      const fromHealth =
        this.canvasAiFlagOn(inner.enabled) ||
        this.canvasAiFlagOn(inner.ai_visible) ||
        this.canvasAiFlagOn(inner.aiVisible);
      this.canvasAiEnabled = fromHealth || admin;
      this.canvasAiHasModel = this.canvasAiFlagOn(inner.has_model) || this.canvasAiFlagOn(inner.hasModel);
      this.canvasAiNoModelMsg = inner.message || inner.msg || "";
      if (persist !== false) {
        this.syncAccountAiVisible(this.canvasAiEnabled);
      }
    },
    syncAccountAiVisible(on) {
      const cur = this.loginAccountInfo || {};
      const flag = on ? 1 : 0;
      if (Number(cur.ai_visible) === flag && Number(cur.aiVisible) === flag) {
        return;
      }
      const next = { ...cur, ai_visible: flag, aiVisible: flag };
      this.$store.commit("setLoginAccountInfo", next);
      setCookie("loginAccountInfo", JSON.stringify(next), 7 * 24 * 60 * 60 * 1000);
    },
    onCanvasAiVisibility() {
      if (document.visibilityState === "visible") {
        this.fetchCanvasAiHealth();
      }
    },
    onCanvasAiPageShow() {
      this.fetchCanvasAiHealth();
    },
    fetchCanvasAiHealth() {
      if (!this.$request.canvasAiHealth) {
        this.applyCanvasAiHealth({ enabled: false, has_model: false }, false);
        return Promise.resolve();
      }
      if (this._canvasAiHealthReq) {
        return this._canvasAiHealthReq;
      }
      this._canvasAiHealthReq = this.$request
        .canvasAiHealth({ t: Date.now() })
        .then((res) => {
          this.applyCanvasAiHealth(res);
        })
        .catch(() => {
          this.applyCanvasAiHealth({ enabled: false, has_model: false }, false);
        })
        .finally(() => {
          this._canvasAiHealthReq = null;
        });
      return this._canvasAiHealthReq;
    },
    openCanvasAi() {
      this.toggleCanvasAi();
    },
    toggleCanvasAi() {
      const panel = this.$refs.canvasAiPanel;
      if (panel && panel.panelVisible && panel.closePanel) {
        panel.closePanel();
        return;
      }
      this.fetchCanvasAiHealth().then(() => {
        this.openCanvasAiPanelIfAllowed();
      });
    },
    openCanvasAiPanelIfAllowed() {
      if (!this.canvasAiEnabled) {
        this.$message.warning("AI 功能未开启");
        return;
      }
      if (!this.canvasAiHasModel) {
        this.$message.warning(this.canvasAiNoModelMsg || "暂无可用免费模型，请联系管理员开启");
        return;
      }
      const panel = this.$refs.canvasAiPanel;
      if (!panel) {
        return;
      }
      if (panel.panelVisible && panel.closePanel) {
        panel.closePanel();
        return;
      }
      if (panel.openPanel) {
        panel.openPanel();
      }
    },
    onAddToAiChat(payload) {
      this.fetchCanvasAiHealth().then(() => {
        if (!this.canvasAiEnabled) {
          this.$message.warning("AI 功能未开启");
          return;
        }
        if (!this.canvasAiHasModel) {
          this.$message.warning(this.canvasAiNoModelMsg || "暂无可用免费模型，请联系管理员开启");
          return;
        }
        const panel = this.$refs.canvasAiPanel;
        if (panel && panel.addComponentsToChat) {
          panel.addComponentsToChat(payload && payload.components);
        }
      });
    },
    locateCanvasError(info) {
      if (!info || !info.pageId) {
        return;
      }
      this.pendingLocateError = info;
      this.canvasErrorBanner = info.summary || "校验未通过";
      if (this.canvasErrorBannerTimer) {
        clearTimeout(this.canvasErrorBannerTimer);
      }
      this.canvasErrorBannerTimer = setTimeout(() => {
        this.canvasErrorBanner = "";
      }, 8000);
      if (String(this.currentPage) === String(info.pageId)) {
        this.applyLocateErrorSelection();
        return;
      }
      this.pageSelect(info.pageId);
    },
    findComponentInTree(list, componentId) {
      if (!list || !componentId) {
        return null;
      }
      for (let i = 0; i < list.length; i++) {
        const c = list[i];
        if (c && String(c.id) === String(componentId)) {
          return { component: c, index: i };
        }
        if (c && Array.isArray(c.propValue)) {
          const nested = this.findComponentInTree(c.propValue, componentId);
          if (nested) {
            return nested;
          }
        }
      }
      return null;
    },
    applyLocateErrorSelection() {
      const info = this.pendingLocateError;
      if (!info) {
        return;
      }
      this.pendingLocateError = null;
      const found = this.findComponentInTree(
        this.componentData,
        info.componentId
      );
      if (found) {
        this.$store.commit("setCurComponent", {
          component: found.component,
          index: found.index,
        });
      }
      const tab = info.tabName || "attr";
      this.$nextTick(() => {
        if (tab === "attr" || this.isHasDirectivesAndEvents(tab)) {
          this.activeName = tab;
        } else {
          this.activeName = "attr";
        }
        this.$nextTick(() => {
          eventBus.$emit("canvasErrorLocatePulse", info.componentId);
          this.scrollErrorFieldIntoView();
        });
      });
    },
    scrollErrorFieldIntoView() {
      const tips = document.querySelectorAll(
        ".home .right .attr-error-tip"
      );
      for (let i = 0; i < tips.length; i++) {
        const t = tips[i];
        if (t && t.textContent && t.textContent.trim()) {
          if (t.scrollIntoView) {
            t.scrollIntoView({ block: "center", behavior: "smooth" });
          }
          break;
        }
      }
    },
    rollbackPageSwitch(oldKey, switchToken) {
      if (switchToken != null && switchToken !== this.pageSwitchToken) {
        return;
      }
      this.suppressPageSwitch = true;
      this.currentPage = String(oldKey);
      this.$nextTick(() => {
        this.suppressPageSwitch = false;
      });
    },
    flushCurrentPageToStore(pageKey) {
      const key =
        pageKey !== undefined && pageKey !== null
          ? pageKey
          : this.selectedCurrentPage;
      if (key === undefined || key === null || !this.canvasAllData) {
        return false;
      }
      const boundId = this.$store.state.componentDataPageId;
      // 画布尚未 restore，或当前 componentData 不属于目标页：禁止误写
      if (boundId == null || String(boundId) !== String(key)) {
        return false;
      }
      const next = flushCurrentPage(
        this.canvasAllData,
        key,
        this.componentData
      );
      this.$store.commit("setCanvasAllData", next);
      this.$store.commit("markCanvasPageLoaded", key);
      return true;
    },
    /**
     * 切页离开时把该页完整数据写入后端，以便内存中可只保留当前页。
     * @returns {Promise<boolean>} 是否落库成功（无工程 id 时视为成功）
     */
    async persistPageIfNeeded(pageId) {
      if (!this.canvasLazyLoad || pageId === undefined || pageId === null) {
        return true;
      }
      const { id, isCommonTemplate } = this.$route.query;
      if (!id || isCommonTemplate) {
        return true;
      }
      const data = parseCanvasAllData(this.canvasAllData);
      const pageArr = this.pickCanvasPageArray(data, pageId);
      if (!pageArr || !pageArr.length) {
        return true;
      }
      // 纯骨架无需重复写库
      if (isPageSkeleton(pageArr)) {
        return true;
      }
      // 从未完整加载过的页不要落库，避免把骨架/错页数据写进 DB
      if (!this.isCanvasPageLoaded(pageId)) {
        return true;
      }
      try {
        const res = await this.$request.saveProjectPage({
          id,
          pageId: String(pageId),
          pageData: stripLazySkeletonFromPage(pageArr),
        });
        if (!res || res.status !== "success") {
          this.$message.error((res && res.msg) || "页面保存失败");
          return false;
        }
        return true;
      } catch (e) {
        console.error("persistPageIfNeeded failed", e);
        this.$message.error("页面保存失败，请检查网络后重试");
        return false;
      }
    },
    /** 保存工程前：将所有已加载的非骨架页落库，避免懒保存漏页 */
    async persistAllLoadedPagesBeforeSave() {
      if (!this.canvasLazyLoad) {
        return true;
      }
      const { id, isCommonTemplate } = this.$route.query;
      if (!id || isCommonTemplate) {
        return true;
      }
      this.flushCurrentPageToStore(this.selectedCurrentPage);
      const pageIds = new Set();
      Object.keys(this.canvasLoadedPageIds || {}).forEach((pid) => {
        if (this.canvasLoadedPageIds[pid]) {
          pageIds.add(String(pid));
        }
      });
      pageIds.add(String(this.selectedCurrentPage));
      for (const pageId of pageIds) {
        const data = parseCanvasAllData(this.canvasAllData);
        const pageArr = this.pickCanvasPageArray(data, pageId);
        if (!pageArr || !pageArr.length || isPageSkeleton(pageArr)) {
          continue;
        }
        const ok = await this.persistPageIfNeeded(pageId);
        if (!ok) {
          return false;
        }
      }
      return true;
    },
    onPersistAllLoadedPagesBeforeSave(payload) {
      const done = payload && payload.done;
      const fail = payload && payload.fail;
      this.persistAllLoadedPagesBeforeSave()
        .then((ok) => {
          if (ok) {
            if (typeof done === "function") {
              done();
            }
          } else if (typeof fail === "function") {
            fail();
          }
        })
        .catch(() => {
          if (typeof fail === "function") {
            fail();
          }
        });
    },
    /** 内存中只保留 keepPageIds 的完整页，其余缩成 Back 骨架 */
    evictOtherPagesFromMemory(keepPageIds) {
      if (!this.canvasLazyLoad || !this.canvasAllData) {
        return;
      }
      const keep = (keepPageIds || []).map((id) => String(id));
      const { canvasAllData } = compactCanvasMemory(this.canvasAllData, keep);
      this.$store.commit("setCanvasAllData", canvasAllData);
      const loadedMap = {};
      keep.forEach((id) => {
        loadedMap[id] = true;
      });
      this.$store.commit("setCanvasLoadedPageIds", loadedMap);
    },
    /** 当前页上 ChildPage 绑定的子页也要能渲染，一并拉取 */
    async ensureBoundChildPagesForPage(pageId) {
      const data = parseCanvasAllData(this.canvasAllData);
      const pageArr = this.pickCanvasPageArray(data, pageId) || [];
      const boundIds = collectBoundChildPageIds(pageArr);
      if (!boundIds.length) {
        return [];
      }
      await this.ensurePagesLoaded(boundIds);
      return boundIds;
    },
    isCanvasPageLoaded(pageId) {
      if (pageId === undefined || pageId === null) {
        return false;
      }
      if (!this.canvasLazyLoad) {
        return true;
      }
      return !!this.canvasLoadedPageIds[String(pageId)];
    },
    markCanvasPagesLoaded(pageIds) {
      (pageIds || []).forEach((id) => {
        this.$store.commit("markCanvasPageLoaded", id);
      });
    },
    onEnsureCanvasPages(payload) {
      const pageIds = (payload && payload.pageIds) || [];
      const done = payload && payload.done;
      this.ensurePagesLoaded(pageIds)
        .then(() => {
          if (typeof done === "function") {
            done();
          }
        })
        .catch(() => {
          if (typeof done === "function") {
            done();
          }
        });
    },
    async ensurePagesLoaded(pageIds) {
      const ids = (pageIds || []).map((id) => String(id));
      for (const id of ids) {
        await this.ensurePageLoaded(id);
      }
    },
    async ensurePageLoaded(pageId) {
      if (pageId === undefined || pageId === null) {
        return true;
      }
      const key = String(pageId);
      if (!this.canvasLazyLoad) {
        return true;
      }
      const { id, isCommonTemplate } = this.$route.query;
      const data = parseCanvasAllData(this.canvasAllData);
      const existing = this.pickCanvasPageArray(data, key);
      if (this.isCanvasPageLoaded(key)) {
        // 新建页可能已标记 loaded 但尚未写入 canvasAllData，不要当成失败去回滚
        if (!existing || !isPageSkeleton(existing)) {
          return true;
        }
        this.$store.commit("unmarkCanvasPageLoaded", key);
      }
      if (!id || isCommonTemplate) {
        this.$store.commit("markCanvasPageLoaded", key);
        return true;
      }
      if (existing && !isPageSkeleton(existing)) {
        this.$store.commit("markCanvasPageLoaded", key);
        return true;
      }
      if (!this.pageLoadPromises || typeof this.pageLoadPromises !== "object") {
        this.pageLoadPromises = {};
      }
      if (!this.pageLoadGens || typeof this.pageLoadGens !== "object") {
        this.pageLoadGens = {};
      }
      if (this.pageLoadPromises[key]) {
        return this.pageLoadPromises[key];
      }
      const gen = (this.pageLoadGens[key] || 0) + 1;
      this.pageLoadGens[key] = gen;
      this.pageLoadPromises[key] = this.$request
        .findProjectPage({ id, pageId: key })
        .then((res) => {
          if (this.pageLoadGens[key] !== gen) {
            return false;
          }
          if (this.$store.state.canvasEditorLeaving) {
            return false;
          }
          if (!res || res.status != "success") {
            this.$message.error((res && res.msg) || "页面加载失败");
            return false;
          }
          const pageArr = normalizePageDataPayload(
            res.data && (res.data.pageData != null ? res.data.pageData : res.data.page_data)
          );
          const latestExisting = this.pickCanvasPageArray(
            parseCanvasAllData(this.canvasAllData),
            key
          );
          const toMerge = pageArr.length
            ? pageArr
            : latestExisting && !isPageSkeleton(latestExisting)
            ? latestExisting
            : null;
          if (!toMerge || !toMerge.length || isPageSkeleton(toMerge)) {
            return false;
          }
          const merged = mergePageIntoCanvasAllData(
            this.canvasAllData,
            key,
            toMerge
          );
          this.$store.commit("setCanvasAllData", merged);
          this.$store.commit("markCanvasPageLoaded", key);
          return true;
        })
        .catch((e) => {
          console.error("ensurePageLoaded failed", e);
          this.$message.error("页面加载失败，请检查网络后重试");
          return false;
        })
        .finally(() => {
          if (this.pageLoadPromises) {
            delete this.pageLoadPromises[key];
          }
        });
      return this.pageLoadPromises[key];
    },
    /** 预览/联动弹窗等需要多页完整数据时加载全部页面 */
    async ensureAllProjectPagesLoaded() {
      if (!this.canvasLazyLoad) {
        return;
      }
      const ids = [];
      const walk = (nodes) => {
        (nodes || []).forEach((n) => {
          ids.push(n.value);
          if (n.children && n.children.length) {
            walk(n.children);
          }
        });
      };
      walk(this.pageOptions);
      await this.ensurePagesLoaded(ids);
    },
    getButtonCountEstimate() {
      const local = getComponentsByType("v-button", this.canvasAllData).length;
      if (!this.canvasLazyLoad) {
        return local;
      }
      return Math.max(local, this.canvasServerButtonCount || 0);
    },
    countPageTree() {
      let n = 0;
      const walk = (arr) => {
        (arr || []).forEach((p) => {
          n += 1;
          if (p.children && p.children.length) {
            walk(p.children);
          }
        });
      };
      walk(this.pageOptions);
      return n;
    },
    /** Editor :key 用，避免 number/string 混用导致不必要的整组件重挂载 */
    viewportPageKey(pageId) {
      if (pageId === null || pageId === undefined) {
        return "";
      }
      return String(pageId);
    },
    /** 与 JSON 对象键、树节点 value 对齐，避免父页数据取不到变成空白画布 */
    pickCanvasPageArray(canvasData, pageKey) {
      if (!canvasData || pageKey === undefined || pageKey === null) {
        return null;
      }
      const s = String(pageKey);
      if (Object.prototype.hasOwnProperty.call(canvasData, s)) {
        return canvasData[s];
      }
      for (const k of Object.keys(canvasData)) {
        if (String(k) === s) {
          return canvasData[k];
        }
      }
      return null;
    },
    pickCanvasStylePageEntry(canvasStyle, pageKey) {
      if (!canvasStyle || pageKey === undefined || pageKey === null) {
        return null;
      }
      const s = String(pageKey);
      const direct = canvasStyle[s];
      if (direct && typeof direct === "object") {
        return direct;
      }
      for (const k of Object.keys(canvasStyle)) {
        if (
          String(k) === s &&
          typeof canvasStyle[k] === "object" &&
          k !== "__proto__"
        ) {
          return canvasStyle[k];
        }
      }
      return null;
    },
    rememberPagePan(pageKey) {
      const editor = this.$refs.editorRef;
      if (!editor || typeof editor.getViewportState !== "function") {
        return;
      }
      if (pageKey === undefined || pageKey === null || pageKey === "") {
        return;
      }
      const st = editor.getViewportState();
      const scale = Number(st && st.scale);
      if (isFinite(scale) && scale > 0) {
        this.globalCanvasScale = scale;
      }
      this.$set(this.pagePanMap, this.viewportPageKey(pageKey), {
        left: st && st.left ? st.left : "0px",
        top: st && st.top ? st.top : "0px",
      });
    },
    isCurrentPageChildCanvas() {
      const meta = this.findPageTreeNode(this.currentPage);
      const back =
        this.componentData && this.componentData.find((c) => c.id === "Back");
      return (
        this.$store.state.isChildPage ||
        (meta && meta.parent != null) ||
        !!(back && back.isChildPage)
      );
    },
    waitEditorThen(switchToken, fn) {
      const waitEditor = (n) => {
        if (switchToken != null && switchToken !== this.pageSwitchToken) {
          return;
        }
        const editor = this.$refs.editorRef;
        if (!editor || !editor.$el) {
          if (n < 120) {
            requestAnimationFrame(() => waitEditor(n + 1));
          }
          return;
        }
        fn(editor);
      };
      waitEditor(0);
    },
    applyCenteredViewport(editor, switchToken, scale) {
      const tryCenter = (m) => {
        if (switchToken != null && switchToken !== this.pageSwitchToken) {
          return;
        }
        const ed = this.$refs.editorRef || editor;
        if (!ed) {
          return;
        }
        const host =
          typeof document !== "undefined"
            ? document.querySelector(".home main .center")
            : null;
        const c =
          typeof document !== "undefined"
            ? document.getElementById("content")
            : null;
        const outer = c && c.parentElement;
        const hostRect = host ? host.getBoundingClientRect() : null;
        const hostOk =
          hostRect && hostRect.width >= 2 && hostRect.height >= 2;
        const ok =
          hostOk ||
          (c && c.clientWidth >= 2 && c.clientHeight >= 2) ||
          (outer && outer.clientWidth >= 2 && outer.clientHeight >= 2);
        if (ok || m >= 80) {
          ed.applyViewportState(ed.getDefaultCenteredViewportState(scale));
          return;
        }
        requestAnimationFrame(() => tryCenter(m + 1));
      };
      tryCenter(0);
    },
    /**
     * 首次进入工程：画布在可见工作区居中。
     */
    applyDefaultViewportForCurrentPage(switchToken) {
      this.globalCanvasScale = 1;
      this.waitEditorThen(switchToken, (editor) => {
        this.applyCenteredViewport(editor, switchToken, 1);
      });
    },
    /** 将当前画布移回可见工作区中心，保留当前缩放 */
    locateCanvasViewport(payload) {
      if (
        payload &&
        payload.pageId != null &&
        String(payload.pageId) !== String(this.currentPage)
      ) {
        this.pendingLocateViewport = true;
        this.pageSelect(payload.pageId);
        return;
      }
      const editor = this.$refs.editorRef;
      if (!editor || typeof editor.getDefaultCenteredViewportState !== "function") {
        return;
      }
      const st =
        typeof editor.getViewportState === "function"
          ? editor.getViewportState()
          : null;
      let scale = Number(st && st.scale);
      if (!isFinite(scale) || scale <= 0) {
        scale = Number(this.globalCanvasScale) || 1;
      }
      this.applyCenteredViewport(editor, null, scale);
    },
    /**
     * 切页：缩放和平移都保持当前视口，不按页重置。
     */
    applyViewportAfterPageSwitch(pageKey, switchToken) {
      this.waitEditorThen(switchToken, (editor) => {
        const v = this._carryViewport || editor.getViewportState();
        if (!v) {
          return;
        }
        let scale = Number(v.scale);
        if (!isFinite(scale) || scale <= 0) {
          scale = this.globalCanvasScale || 1;
        }
        editor.applyViewportState({
          scale,
          left: v.left || "0px",
          top: v.top || "0px",
        });
      });
    },
    async setCanvasCache(data) {
      if (this.$store.state.canvasEditorLeaving) {
        return;
      }
      var key = this.cacheCanvasDataKey;
      if (!key) {
        const { id, temporaryId } = this.$route.query;
        key = this.loginAccountInfo.user_id + ':' + (id || temporaryId);
      }
      this.$store.commit('setCanvasAllData', data);
      if (!key) {
        return;
      }
      await coalescedSetProjectCache(this.$request, {
        key,
        value: data,
        checkLeaving: () => this.$store.state.canvasEditorLeaving,
      });
      if (this.$store.state.canvasEditorLeaving) {
        return;
      }
    },
    loadChangeCancel() {
      this.loadCacheData = null;
      this.loadChangeConfirm()
    },
    loadChangeConfirm() {
      if (this.$store.state.canvasEditorLeaving) {
        return;
      }
      if (this.loadCacheData || this.panel_data) {
        const fromCache = !!this.loadCacheData;
        let rawData = this.loadCacheData || this.panel_data;
        if (fromCache && this.canvasLazyLoad) {
          const parsed = parseCanvasAllData(rawData);
          const serverParsed = this.panel_data
            ? parseCanvasAllData(this.panel_data)
            : {};
          const firstPage = String(
            (this.page_sort && this.page_sort[0]) || this.currentPage || "1"
          );
          Object.keys(parsed).forEach((pageId) => {
            if (isPageSkeleton(parsed[pageId])) {
              const serverPage = serverParsed[pageId] || serverParsed[String(pageId)];
              if (serverPage && !isPageSkeleton(serverPage)) {
                parsed[pageId] = serverPage;
              }
            }
            // 草稿里的完整页保留（用户可能正在编辑非首页），切页时不再被压成骨架
          });
          if (isPageSkeleton(parsed[firstPage])) {
            const serverFirst = serverParsed[firstPage];
            if (serverFirst && !isPageSkeleton(serverFirst)) {
              parsed[firstPage] = serverFirst;
            }
          }
          rawData = stringifyCanvasAllData(parsed);
        }
        let data = this.handleInitData(rawData);
        const parsedInit = parseCanvasAllData(data);
        if (fromCache && !Object.keys(parsedInit).length && this.panel_data) {
          data = this.handleInitData(this.panel_data);
        }
        this.$store.commit('setCanvasAllData', data)
        if (fromCache) {
          const parsedAfter = parseCanvasAllData(data);
          const loadedMap = {};
          Object.keys(parsedAfter).forEach((pid) => {
            const arr = parsedAfter[pid];
            // 草稿里「仅 Back」且无完整组件的页不当成已加载，切页时走 findPage
            if (Array.isArray(arr) && arr.length > 1 && !isPageSkeleton(arr)) {
              loadedMap[String(pid)] = true;
            }
          });
          const firstPage = String(
            (this.page_sort && this.page_sort[0]) || this.currentPage || "1"
          );
          const firstArr =
            parsedAfter[firstPage] ||
            this.pickCanvasPageArray(parsedAfter, firstPage);
          if (firstArr && !isPageSkeleton(firstArr)) {
            loadedMap[firstPage] = true;
          }
          this.$store.commit("setCanvasLoadedPageIds", loadedMap);
        }
      }
      this.isInitSave = true;
      this.initData();
      this.loadChangeDialog = false;
    },
    pageSelect(value, parentVal) {
      // 以树结构为准，避免仅依赖 left 传入的 parentVal 导致滞后（父页被误判为子页）
      const meta = this.findPageTreeNode(value);
      this.currentPageParent =
        meta && meta.parent != null ? meta.parent.value : null;
      this.currentPage = String(value);
    },
    async getListComp() {
      try {
        this.$changeLoadingState(true);
        const ret = await this.$request.getListType({
          custom_type: 'weather'
        });
        const datas = ret && ret.data || [];
        let weatherData = datas.map(({custom_url: id, custom_name: text}) => ({id, text}))

        this.$store.commit("setWeatherAttrConfig", weatherData);
        // 设置天气组件的默认样式
        for (let i = 0; i < this.allComponentList.length; i++) {
          if (this.allComponentList[i].component === 'Weather') {
            this.allComponentList[i].style.imgStyle = datas[0] && datas[0].custom_url || '';
            this.allComponentList[i].style.imgStyleName = datas[0] && datas[0].custom_name || '';
            break;
          }
        }
      } catch (error) {
        console.log(error);
      }
      this.$changeLoadingState(false);
    },
    inputValChange({key, val, id, otherVal, pageKey, prefixKey}) {
      const validateFunc = ATTRS_VALIDATE_MAP[key] && ATTRS_VALIDATE_MAP[key].validate;
      if (validateFunc && typeof validateFunc === 'function') {
        pageKey = pageKey || this.selectedCurrentPage;
        let _this = this;
        let validateData = JSON.parse(JSON.stringify(this.projectValidateMap));
        let validateRepeat = [];
        if (key === "alias") {
          // 别名需要额外校验重复
          if (!validateData.alias) {
            validateData.alias = {};
          }
          if (!validateData.alias[pageKey]) {
            validateData.alias[pageKey] = [];
          }
          validateRepeat = validateData.alias[pageKey];
        }
        validateFunc(val, (errorMsg, pushVal) => {
          if (pushVal) {
            // 需要校验重复的数据，将当前值暂存（同一值不重复写入，避免改错再改回被当成重复）
            if (!validateRepeat.includes(pushVal)) {
              validateRepeat.push(pushVal);
            }
            _this.$store.commit("setProjectValidateMap", validateData);
          }
          const remainErrorData =
            (sessionStorage.getItem("canvasErrorMap") &&
              JSON.parse(sessionStorage.getItem("canvasErrorMap"))) ||
            {};
          if (!remainErrorData[pageKey]) {
            remainErrorData[pageKey] = {}
          }
          if (!remainErrorData[pageKey][id]) {
            remainErrorData[pageKey][id] = {};
          }
          const msg = errorMsg || '';
          if (prefixKey) {
            if (!remainErrorData[pageKey][id][prefixKey]) {
              remainErrorData[pageKey][id][prefixKey] = {};
            }
            if (msg) {
              remainErrorData[pageKey][id][prefixKey][key] = msg;
            } else {
              delete remainErrorData[pageKey][id][prefixKey][key];
              if (!Object.keys(remainErrorData[pageKey][id][prefixKey]).length) {
                delete remainErrorData[pageKey][id][prefixKey];
              }
            }
          } else if (msg) {
            remainErrorData[pageKey][id][key] = msg;
          } else {
            delete remainErrorData[pageKey][id][key];
          }
          if (
            remainErrorData[pageKey][id] &&
            !Object.keys(remainErrorData[pageKey][id]).length
          ) {
            delete remainErrorData[pageKey][id];
          }
          sessionStorage.setItem(
            "canvasErrorMap",
            JSON.stringify(remainErrorData)
          );
          _this.$store.commit("setCurErrorMap");
        }, otherVal, validateRepeat);
      }
    },
    initData() {
      //还原页面的个数
      this.restorePageOptions();
      this.restore(this.currentPage);
      // 全局监听按键事件
      listenGlobalKeyDown();
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.applyDefaultViewportForCurrentPage(null);
        });
      });
      const settleBaseline = () => {
        this.schedulePersistBaseline();
      };
      if (this.canvasLazyLoad && this.currentPage != null) {
        this.ensureBoundChildPagesForPage(this.currentPage)
          .then((boundIds) => {
            if (boundIds && boundIds.length) {
              this.evictOtherPagesFromMemory([this.currentPage, ...boundIds]);
            }
          })
          .catch(() => {})
          .then(settleBaseline);
      } else {
        settleBaseline();
      }
    },
    schedulePersistBaseline() {
      if (this._persistBaselineTimer) {
        clearTimeout(this._persistBaselineTimer);
      }
      this._persistBaselineTimer = setTimeout(() => {
        this._persistBaselineTimer = null;
        const tb = this.$refs.toolbarRef;
        if (tb && typeof tb.capturePersistBaseline === "function") {
          tb.capturePersistBaseline();
        }
      }, 120);
    },
    eidtorOnBlurHandler() {
      this.$store.commit("switchIsEditorOnBlur", true);
    },
    editorOnFocusHandler() {
      this.$store.commit("switchIsEditorOnBlur", false);
    },
    handleInitData(data) {
      return normalizeCanvasAllDataString(data);
    },
    setLocalData() {
      const { id, isCommonTemplate } = this.$route.query;
      if (!id) {
        // 新建工程：必须丢掉上一份模板/工程残留，否则画布会沿用 Vuex 里的旧组件
        this.resetEditorForNewProject();
        this.$store.commit("setCanvasLazyLoad", false);
        this.getCacheData();
        return;
      }
      this.$request.getProjectInfo({ id, isCommonTemplate })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            // 失败时也尝试加载缓存，避免 Editor loading 一直不结束
            this.getCacheData();
            return;
          }
          const {
            panel_data,
            project_height,
            project_width,
            project_name,
            page_sort,
            interaction_package_data,
            lazy_load,
            button_count,
            file_resouces,
          } = res.data || {};

          this.page_sort = page_sort;
          sessionStorage.setItem("pageSortData", JSON.stringify(page_sort));

          this.projectName = project_name;
          this.panel_data = panel_data;
          this.$store.commit("setProjectFileResouces", file_resouces || []);

          const useLazy = !!lazy_load && !isCommonTemplate;
          this.$store.commit("setCanvasLazyLoad", useLazy);
          this.$store.commit("setCanvasServerButtonCount", button_count || 0);
          const loadedMap = {};
          if (useLazy) {
            // 懒加载打开时，payload 里非首页即使看起来像「只有 Back」也不能标 loaded
            // （旧数据可能没有 _lazySkeleton，误标后切页不再 findPage，会把空页写回）
            const firstId =
              page_sort && page_sort.length ? String(page_sort[0]) : "";
            if (firstId) {
              const parsedPanel = parseCanvasAllData(panel_data);
              const firstArr =
                parsedPanel[firstId] ||
                this.pickCanvasPageArray(parsedPanel, firstId);
              if (firstArr && !isPageSkeleton(firstArr)) {
                loadedMap[firstId] = true;
              } else if (firstArr && Array.isArray(firstArr) && firstArr.length > 1) {
                loadedMap[firstId] = true;
              }
            }
          } else if (panel_data) {
            try {
              Object.keys(JSON.parse(panel_data)).forEach((pid) => {
                loadedMap[String(pid)] = true;
              });
            } catch (e) {
              /* ignore */
            }
          }
          this.$store.commit("setCanvasLoadedPageIds", loadedMap);

          let interactionPackageData = interaction_package_data ? JSON.parse(interaction_package_data) : [];
          sessionStorage.setItem("interactionPackageData", JSON.stringify(interactionPackageData));
          this.initErrorMap();
          const firstPage =
            page_sort && page_sort.length ? String(page_sort[0]) : String(this.currentPage);
          sessionStorage.setItem(
            "canvasStyle",
            JSON.stringify({
              height: Number(project_height),
              width: Number(project_width),
              scale: 100,
              [firstPage]: {
                height: Number(project_height),
                width: Number(project_width),
                scale: 100
              }
            })
          );
          this.$store.commit(
            "setProjectStyle",
            {
                height: Number(project_height),
                width: Number(project_width),
                scale: 100
            }
          );
          // 成功拿到工程详情后再读取缓存，避免 panel_data 还未赋值导致时序问题
          this.getCacheData();
        })
        .catch(() => {
          this.$message.error("工程数据加载失败，请稍后重试");
          // 兜底：即使详情接口异常，也要让编辑器初始化流程结束
          this.getCacheData();
        });
    },
    resetEditorForNewProject() {
      this.panel_data = null;
      this.loadCacheData = null;
      this.copyCanvasDatas = null;
      this.page_sort = ["1"];
      this.currentPage = "1";
      this.currentPageParent = null;
      this.isInitSave = false;
      this.loadChangeDialog = false;
      this.globalCanvasScale = 1;
      this.pagePanMap = {};
      clearCanvasSessionStorage();
      this.$store.commit("removeCache");
    },
    getCacheData() {
      const { id, temporaryId } = this.$route.query;
      var key = this.loginAccountInfo.user_id + ':' + (id || temporaryId);
      this.$store.commit('setCacheCanvasDataKey', key)

      this.$request.getProjectCache(key).then((res) => {
        if (this.$store.state.canvasEditorLeaving) {
          return;
        }
        if (this.cacheCanvasDataKey !== key) {
          return;
        }
        this.isInitLoaded = true;
        if (res.status != "success") {
          this.$message.error(res.msg);
          this.loadChangeConfirm();
          return;
        }
        if (res.data) {
          // 说明有缓存数据
          if (res.data !== this.initCanvasData && res.data !== this.panel_data) {
            this.loadChangeDialog = true;
            this.loadCacheData = res.data;
            return;
          }
        }
        // 没有缓存数据
        this.loadChangeConfirm()
      }).catch(() => {
        if (this.$store.state.canvasEditorLeaving) {
          return;
        }
        this.isInitLoaded = true;
        this.loadChangeConfirm();
      })
    },
    initErrorMap() {
      let map = {};
      this.page_sort.map((id) => {
        map[id] = {};
      });
      sessionStorage.setItem("canvasErrorMap", JSON.stringify(map));
    },
    restorePageOptions() {
      if (this.canvasAllData) {
        const data = parseCanvasAllData(this.canvasAllData);
        const arr = [];
        var childMap = {};
        for (const p in data) {
          const pageArr = data[p];
          if (!Array.isArray(pageArr) || !pageArr[0]) {
            continue;
          }
          const back = pageArr[0];
          const pageName =
            (back.style && back.style.pageName) || `页面${p}`;
          var item = {
            label: pageName,
            value: p,
          };
          arr.push(item);
          if (data[p][0].isChildPage) {
            var parentId = data[p][0].parentId;
            const parentKey = parentId != null ? String(parentId) : "";
            if (parentKey) {
              if (!childMap[parentKey]) {
                childMap[parentKey] = [];
              }
              childMap[parentKey].push(item);
            }
          }
        }
        var sortdata = [1];
        try {
          sortdata = JSON.parse(sessionStorage.getItem("pageSortData")) || [1];
          this.page_sort = sortdata;
        } catch (error) {
        }
        const sortedArr = sortdata.reduce((res, page) => {
          let arrItem = arr.find((item) => (item.value + '') == (page + ''));
          if (arrItem) {
            const childKey = String(page);
            if (childMap[childKey]) {
              arrItem.children = childMap[childKey];
            }
            res.push(arrItem);
          }
          return res;
        }, []);
        this.$store.commit("setPageOptions", sortedArr);
        this.currentPage =
          sortedArr[0] != null ? String(sortedArr[0].value) : this.currentPage;
        pruneCanvasErrorMap(data);
      }
    },
    getPageData(key) {
      const meta = this.findPageTreeNode(key);
      const name =
        (meta && meta.node && meta.node.label) ||
        `新页面${this.pageOptions.length}`;
      const obj = {
        ...BACK_COMPONENT(name),
      };
      if (meta && meta.parent != null) {
        obj.style.pageWidth = 1200;
        obj.style.pageHeight = 700;
        obj.isChildPage = true;
        obj.parentId = meta.parent.value;
      }
      return obj;
    },
    /** 以左侧树关系为准，纠正 Back 的主/子页面标记，避免切页后画布尺寸状态错乱 */
    normalizeBackByTree(pageArr, pageKey) {
      if (!Array.isArray(pageArr) || pageArr.length === 0) {
        return pageArr;
      }
      const backInd = pageArr.findIndex((a) => a && a.id === "Back");
      if (backInd === -1) {
        return pageArr;
      }
      const ret = JSON.parse(JSON.stringify(pageArr));
      const back = ret[backInd] || {};
      if (!back.style || typeof back.style !== "object") {
        back.style = {};
      }
      const meta = this.findPageTreeNode(pageKey);
      const isChild = !!(meta && meta.parent != null);
      if (isChild) {
        back.isChildPage = true;
        back.parentId = meta.parent.value;
        if (isEmpty(back.style.pageWidth)) {
          back.style.pageWidth = 1200;
        }
        if (isEmpty(back.style.pageHeight)) {
          back.style.pageHeight = 700;
        }
      } else {
        delete back.isChildPage;
        delete back.parentId;
        if (back.style) {
          delete back.style.pageWidth;
          delete back.style.pageHeight;
        }
      }
      ret[backInd] = back;
      return ret;
    },
    normalizeCanvasStyleEntry(raw, fallback) {
      const fb = fallback || {};
      const style = raw && typeof raw === "object" ? { ...raw } : {};
      const toNum = (v) => {
        const n = Number(v);
        return isFinite(n) ? n : null;
      };
      const w =
        toNum(style.width) ??
        toNum(fb.width) ??
        toNum(this.projectStyleData && this.projectStyleData.width) ??
        1200;
      const h =
        toNum(style.height) ??
        toNum(fb.height) ??
        toNum(this.projectStyleData && this.projectStyleData.height) ??
        740;
      const s =
        toNum(style.scale) ??
        toNum(fb.scale) ??
        100;
      return {
        ...style,
        width: w,
        height: h,
        scale: s,
      };
    },
    restore(key) {
      const pageKey = key != null ? String(key) : key;
      // 必须先于 setComponentData / recordSnapshot，保证快照里 Back.pageId 与 isChildPage 与当前页一致
      this.$store.commit("setSelectedCurrentPage", pageKey);
      this.$store.commit("setComponentDataPageId", pageKey);
      // 用保存的数据恢复画布
      if (this.canvasAllData) {
        let canvasData = {};
        try {
          canvasData = this.copyCanvasDatas
            ? parseCanvasAllData(this.copyCanvasDatas)
            : parseCanvasAllData(this.canvasAllData);
        } catch (e) {
          canvasData = parseCanvasAllData(this.canvasAllData);
        }
        const pageArr = this.pickCanvasPageArray(canvasData, pageKey);
        if (!pageArr) {
          this.$store.commit("setCurComponent", {
            component: null,
            index: null,
          });
          // 页面名称需要判断是否已有，如果没有再用新的值

          this.$store.commit("setComponentData", [
            this.getPageData(pageKey)
          ]);
          this.$store.commit("recordSnapshot");
        } else {
          const normalizedPageArr = this.normalizeBackByTree(pageArr, pageKey);
          this.$store.commit("setComponentData", normalizedPageArr);
          this.$store.commit("recordSnapshot");
        }
        // 如果有复制数据，将临时存储数据移除掉
        this.copyCanvasDatas = null;
      } else {
        this.currentPage = "1";
        this.page_sort = ["1"];
        this.$store.commit("setPageOptions", [
          {
            label: "新页面1",
            value: 1,
          },
        ]);
        this.$store.commit("setSelectedCurrentPage", 1);
        this.$store.commit("setComponentDataPageId", "1");
        const emptyPage = [BACK_COMPONENT()];
        this.$store.commit("setComponentData", emptyPage);
        this.$store.commit("setCurComponent", {
          component: emptyPage[0],
          index: 0,
        });
        this.$store.commit("clearSnap");
        this.$store.commit("recordSnapshot");
        this.setCanvasCache(
          JSON.stringify({
            1: emptyPage,
          })
        );
        sessionStorage.setItem("pageSortData", JSON.stringify(["1"]));
        sessionStorage.setItem(
          "canvasErrorMap",
          JSON.stringify({
            1: {},
          })
        );
        this.$store.commit("setCurErrorMap");
      }

      // 顶栏工程宽高全局生效：切主页面/子页面都不得改回 1200×740。子页面尺寸只存在 Back.pageWidth/pageHeight。
      const projectStyle = this.$store.state.projectStyleData || {};
      const canvasStyleNow = this.$store.state.canvasStyleData || {};
      const nextCanvasStyle = {
        ...canvasStyleNow,
        width: Number(projectStyle.width) || Number(canvasStyleNow.width) || 1200,
        height: Number(projectStyle.height) || Number(canvasStyleNow.height) || 740,
        scale:
          Number(canvasStyleNow.scale) ||
          Number(projectStyle.scale) ||
          100,
      };
      this.$store.commit("setCanvasStyle", nextCanvasStyle);
      let stored = {};
      try {
        stored = JSON.parse(sessionStorage.getItem("canvasStyle") || "{}") || {};
      } catch (e) {
        stored = {};
      }
      sessionStorage.setItem(
        "canvasStyle",
        JSON.stringify({
          ...stored,
          width: nextCanvasStyle.width,
          height: nextCanvasStyle.height,
          scale: nextCanvasStyle.scale,
          [pageKey]: {
            ...(stored[pageKey] && typeof stored[pageKey] === "object"
              ? stored[pageKey]
              : {}),
            width: nextCanvasStyle.width,
            height: nextCanvasStyle.height,
            scale: nextCanvasStyle.scale,
          },
        })
      );
    },
    showSortDialog() {
      this.$refs.dragableSort.switchDialogVisible(true);
    },
    changeProjectName(v) {
      this.projectName = v;
    },

    resetID(data) {
      data.forEach((item) => {
        if (item.id == "Back") return;
        item.id = generateID();
      });
      return data;
    },
    handlerEcologicalCompProps(component) {
      component.compType = ECOLOGICAL_SIGN;
      component.component = "EcologicalGroup";
      component.networkConfig = component.networkConfig || {
        ipAdress: '',
        port: ''
      };
      if (component.propValue) {
        component.propValue.map((item, index) => {
          component.propValue[index].id = uuid();
          component.propValue[index].parentid = component.id;
          component.propValue[index].compType = ECOLOGICAL_CHILDREN_SIGN;
        });
      }
      return component;
    },
    handleDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      const index = e.dataTransfer.getData("index");
      const rectInfo = this.editor.getBoundingClientRect();
      // console.log(this.editor, rectInfo, e.clientX, e.clientY);
      if (e.clientY < rectInfo.top || e.clientY > rectInfo.bottom || e.clientX < rectInfo.left || e.clientX > rectInfo.right) {
        // 如果没有拖拽在画布里面，不能渲染
        return;
      }
      const compType = e.dataTransfer.getData("compType");
      let component = {};
      if (compType === ECOLOGICAL_SIGN) {
        try {
          component = JSON.parse(this.ecologicalComp[index].ecology_data);
        } catch (error) {
          this.$message.error('生态组件数据不正确，请检查');
          return;
        }
        component.id = uuid();
        // 增加生态组件的标志
        component = this.handlerEcologicalCompProps(component);
      } else if (index.indexOf("matrix") > -1) {
        component = deepCopy(matrixComponents[index]);
        component.id = uuid();
        component.style.alias = component.style.alias + uuid();
      } else if (compType === PLAYER_CONTROL_SIGN) {
        const addCount = PLAYER_CONTROL_BUTTON_COUNTS[index] || 4;
        const { btns } =
          (atob(this.$route.query.limits) &&
            JSON.parse(atob(this.$route.query.limits))) ||
          {};
        if (this.getButtonCountEstimate() + addCount > btns * 1) {
          this.$message.error("按钮个数不得超过最高限制个数");
          return;
        }
        component = buildPlayerControlGroup(index, e.offsetX, e.offsetY);
      } else {
        component = deepCopy(this.allComponentList[index]);
        component.id = uuid();
      }

      if (component.component == "v-button") {
        const { btns } =
          (atob(this.$route.query.limits) &&
            JSON.parse(atob(this.$route.query.limits))) ||
          {};
        if (this.getButtonCountEstimate() >= btns * 1) {
          this.$message.error("按钮个数不得超过最高限制个数");
          return;
        }
        component.style.alias = component.style.alias + uuid();
      }
      // let currentScale = this.editor.getAttribute('data-scale');
      let currentScale = 1;
      const canvasStyle = JSON.parse(sessionStorage.getItem("canvasStyle"));
      const currentPageStyle = canvasStyle;
      if (compType !== PLAYER_CONTROL_SIGN) {
        // component.style.top = Math.ceil((e.clientY - rectInfo.y) / currentScale);
        component.style.top = e.offsetY;
        if ((component.style.height + component.style.top) > currentPageStyle.height) {
          component.style.top = currentPageStyle.height - component.style.height;
        }
        // component.style.left = Math.ceil((e.clientX - rectInfo.x) / currentScale);
        component.style.left = e.offsetX;
        if ((component.style.width + component.style.left) > currentPageStyle.width) {
          component.style.left = currentPageStyle.width - component.style.width;
        }
      } else if (component.component === "Group") {
        if ((component.style.height + component.style.top) > currentPageStyle.height) {
          component.style.top = Math.max(0, currentPageStyle.height - component.style.height);
        }
        if ((component.style.width + component.style.left) > currentPageStyle.width) {
          component.style.left = Math.max(0, currentPageStyle.width - component.style.width);
        }
        const hasChildLayout = component.propValue?.every(
          (c) => c.groupStyle && Object.keys(c.groupStyle).length > 0
        );
        if (!hasChildLayout) {
          createGroupStyle(component);
        }
      }
      if (compType === ECOLOGICAL_SIGN) {
        component = this.setChildCompPos(component);
      }
      eventBus.$emit("hideArea")
      component.groupStyle = {}

      // 设置层级
      const canvasData = parseCanvasAllData(this.canvasAllData);
      const currentPageDatas =
        this.pickCanvasPageArray(canvasData, this.selectedCurrentPage) ||
        this.componentData ||
        [];
      component.style.zIndex = currentPageDatas.length + 1;

      this.$store.commit("addComponent", { component});
      this.$store.commit("recordSnapshot");
    },
    setChildCompPos(component) {
      if (component.propValue && component.propValue.length !== 0) {
        const compH = component.style.height;
        const compW = component.style.width;
        const compTop = component.style.top;
        const compLeft = component.style.left;
        component.propValue.map((item, index) => {
          component.propValue[index].style.top = parseInt(parseFloat(item.groupStyle.top) / 100 * compH + compTop);
          component.propValue[index].style.left = parseInt(parseFloat(item.groupStyle.left) / 100 * compW + compLeft);
        });
      }
      return component;
    },
    handleDragOver(e) {
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },

    handleMouseDown(e) {
      // 右键在 capture 阶段已处理，bubble 阶段不要清掉选中态
      if (e && e.button === 2) {
        return;
      }
      // 点在画布空白（未点到 Shape）时先清标记，mouseup 再切回背景
      this.$store.commit("setClickComponentStatus", false);
    },

    isPointerInCanvasContent(e) {
      const content = document.getElementById("content");
      if (!content || !content.getBoundingClientRect) {
        return false;
      }
      const rect = content.getBoundingClientRect();
      const x = e && e.clientX;
      const y = e && e.clientY;
      if (typeof x !== "number" || typeof y !== "number") {
        return content.contains(e.target);
      }
      return (
        x >= rect.left &&
        x <= rect.right &&
        y >= rect.top &&
        y <= rect.bottom
      );
    },

    findShapeElementFromPoint(x, y) {
      const stack = document.elementsFromPoint(x, y) || [];
      for (let i = 0; i < stack.length; i++) {
        const el = stack[i];
        if (!el) {
          continue;
        }
        if (el.classList && el.classList.contains("shape")) {
          return el;
        }
        if (el.closest) {
          const shapeEl = el.closest(".shape");
          if (shapeEl) {
            return shapeEl;
          }
        }
      }
      const editor = document.getElementById("editor");
      if (!editor) {
        return null;
      }
      const shapes = editor.querySelectorAll(".shape[data-shape-id]");
      for (let i = shapes.length - 1; i >= 0; i--) {
        const node = shapes[i];
        if (!node || !node.getBoundingClientRect) {
          continue;
        }
        const rect = node.getBoundingClientRect();
        if (
          x >= rect.left &&
          x <= rect.right &&
          y >= rect.top &&
          y <= rect.bottom
        ) {
          return node;
        }
      }
      return null;
    },

    openCanvasContextMenuFromEvent(e) {
      if (!e || !this.isPointerInCanvasContent(e)) {
        return false;
      }
      if (e.target && e.target.closest && e.target.closest(".contextmenu")) {
        return false;
      }
      e.stopPropagation();
      this.$store.commit("setClickComponentStatus", true);
      this.selectComponentFromPoint(e.clientX, e.clientY);
      this.showCanvasContextMenuAt(e.clientX, e.clientY);
      return true;
    },

    handleCanvasContextMenu(e) {
      this.openCanvasContextMenuFromEvent(e);
    },

    selectComponentFromPoint(x, y) {
      const shapeEl = this.findShapeElementFromPoint(x, y);
      if (!shapeEl) {
        return;
      }
      const shapeId = shapeEl.getAttribute("data-shape-id");
      if (!shapeId) {
        return;
      }
      const list = this.componentData || [];
      const index = list.findIndex(
        (c) => c && String(c.id) === String(shapeId)
      );
      if (index === -1) {
        return;
      }
      const areaList = (this.areaData && this.areaData.components) || [];
      const inArea = areaList.some(
        (c) => c && String(c.id) === String(shapeId)
      );
      this.$store.commit("setClickComponentStatus", true);
      if (inArea) {
        return;
      }
      this.$store.commit("setCurComponent", {
        component: list[index],
        index,
      });
      eventBus.$emit("hideArea");
    },

    showCanvasContextMenuAt(clientX, clientY) {
      const menuW = 160;
      const menuH = 360;
      let left = clientX;
      let top = clientY;
      const maxLeft = Math.max(0, window.innerWidth - menuW);
      const maxTop = Math.max(0, window.innerHeight - menuH);
      if (left > maxLeft) left = maxLeft;
      if (top > maxTop) top = maxTop;
      if (left < 0) left = 0;
      if (top < 0) top = 0;
      const pastePoint = clientPointToCanvas(clientX, clientY);
      this.contextMenuOpenedAt = Date.now();
      this.$store.commit("showContextMenu", {
        top,
        left,
        pasteCanvasTop: pastePoint.top,
        pasteCanvasLeft: pastePoint.left,
      });
    },

    bindGlobalCanvasContextMenu() {
      this._onGlobalCanvasMouseDown = (e) => {
        if (e.button === 0) {
          if (e.target && e.target.closest && e.target.closest(".contextmenu")) {
            return;
          }
          this.$store.commit("hideContextMenu");
          return;
        }
        if (e.button !== 2 && e.which !== 3) {
          return;
        }
        if (!this.isPointerInCanvasContent(e)) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        this.openCanvasContextMenuFromEvent(e);
      };
      this._onGlobalCanvasContextMenu = (e) => {
        if (!this.isPointerInCanvasContent(e)) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        this.openCanvasContextMenuFromEvent(e);
      };
      document.addEventListener("mousedown", this._onGlobalCanvasMouseDown, true);
      document.addEventListener(
        "contextmenu",
        this._onGlobalCanvasContextMenu,
        true
      );
    },

    unbindGlobalCanvasContextMenu() {
      if (this._onGlobalCanvasMouseDown) {
        document.removeEventListener(
          "mousedown",
          this._onGlobalCanvasMouseDown,
          true
        );
        this._onGlobalCanvasMouseDown = null;
      }
      if (this._onGlobalCanvasContextMenu) {
        document.removeEventListener(
          "contextmenu",
          this._onGlobalCanvasContextMenu,
          true
        );
        this._onGlobalCanvasContextMenu = null;
      }
    },

    selectBackgroundComponent() {
      const list = this.componentData || [];
      const backInd = list.findIndex((c) => c && c.id === "Back");
      if (backInd === -1) {
        return;
      }
      this.$store.commit("setCurComponent", {
        component: list[backInd],
        index: backInd,
      });
      eventBus.$emit("hideArea");
    },

    deselectCurComponent(e) {
      // 框选多选完成后 isClickComponent 为 true；多选态下也不切回背景
      const multiCount =
        (this.areaData &&
          this.areaData.components &&
          this.areaData.components.length) ||
        0;
      if (!this.isClickComponent && multiCount === 0) {
        this.selectBackgroundComponent();
      }
    },
    addChildPage() {
      const { pages } =
        (atob(this.$route.query.limits) &&
          JSON.parse(atob(this.$route.query.limits))) ||
        {};
      if (this.countPageTree() >= pages * 1) {
        this.$message.error("不得超过页面最高限制个数");
        return;
      }
      const sel = this.selectedCurrentPage != null
        ? String(this.selectedCurrentPage)
        : String(this.currentPage);
      var ind = this.pageOptions.findIndex(
        (a) => String(a.value) === sel
      );
      if (ind === -1) {
        this.$message.warning("未找到当前主页面，请先在左侧树中选中一个主页面");
        return;
      }
      this.flushCurrentPageToStore(this.selectedCurrentPage);
      var currentPage = this.pageOptions[ind];
      var newPage = JSON.parse(JSON.stringify(this.pageOptions));
      if (!currentPage.children) {
        newPage[ind].children = [];
      }
      const id = uuid();
      newPage[ind].children.push({
        label: `子页面${newPage[ind].children.length + 1}`,
        value: id
      });
      const parentPageId = newPage[ind].value;
      this.$store.commit("setPageOptions", newPage);
      this.$store.commit("markCanvasPageLoaded", id);
      this.$nextTick(() => {
        if (this.$refs.leftComp) {
          this.$refs.leftComp.addExpandedKey(parentPageId);
        }
        this.pageSelect(id, parentPageId);
      });
    },
    addNewPage() {
      if (this.addNewPageBtnDis) {
        return;
      }
      this.addNewPageBtnDis = true;
      setTimeout(() => {
        this.addNewPageBtnDis = false;
      }, 700)
      const { pages } =
        (atob(this.$route.query.limits) &&
          JSON.parse(atob(this.$route.query.limits))) ||
        {};
      //判断是否超套餐个数
      if (this.countPageTree() >= pages * 1) {
        this.$message.error("不得超过页面最高限制个数");
        return;
      }
      this.flushCurrentPageToStore(this.selectedCurrentPage);
      const id = uuid();
      this.$store.commit("setPageOptions", [
        ...this.pageOptions,
        {
          label: `新页面${this.pageOptions.length + 1}`,
          value: id,
        }
      ]);
      this.$store.commit("markCanvasPageLoaded", id);
      this.currentPage = String(id);
      this.currentPageParent = null;
      this.page_sort.push(id);
      sessionStorage.setItem("pageSortData", JSON.stringify(this.page_sort));
    },
    /** 查找左侧树中的页面节点（主页面或子页面），用于复制、命名等 */
    findPageTreeNode(pageVal) {
      if (pageVal === null || pageVal === undefined) {
        return null;
      }
      const v = String(pageVal);
      for (let i = 0; i < this.pageOptions.length; i++) {
        const p = this.pageOptions[i];
        if (String(p.value) === v) {
          return { node: p, parent: null };
        }
        if (p.children && p.children.length) {
          for (let j = 0; j < p.children.length; j++) {
            const c = p.children[j];
            if (String(c.value) === v) {
              return { node: c, parent: p };
            }
          }
        }
      }
      return null;
    },
    /**
     * 递归重新生成组件及其所有子组件的ID
     * 处理 Group 组合组件和生态组件的子元素ID冲突问题
     */
    regenerateComponentIds(component) {
      if (!component || typeof component !== 'object') return component;

      // 深拷贝组件避免引用污染
      const newComponent = JSON.parse(JSON.stringify(component));

      // 非 Back 组件重新生成ID
      if (newComponent.component !== 'Back') {
        newComponent.id = uuid();
      }

      // 处理 Group 组合组件的子组件 (在 propValue 中)
      if (newComponent.component === 'Group' && newComponent.propValue) {
        newComponent.propValue = newComponent.propValue.map(child => {
          const newChild = this.regenerateComponentIds(child);
          // 更新 parentId 指向新的父组件ID
          if (newChild.style && newComponent.id) {
            newChild.parentId = newComponent.id;
          }
          return newChild;
        });
      }

      // 处理生态组件的子元素 (在 propValue 中)
      if (newComponent.compType === 'ECOLOGICAL_SIGN' && newComponent.propValue) {
        newComponent.propValue = newComponent.propValue.map(child => {
          const newChild = JSON.parse(JSON.stringify(child));
          newChild.id = uuid();
          newChild.parentid = newComponent.id;
          return newChild;
        });
      }

      return newComponent;
    },

    copyPageData(sourcePageId) {
      const pageId =
        sourcePageId != null ? String(sourcePageId) : String(this.currentPage);
      const meta = this.findPageTreeNode(pageId);
      const id = uuid();
      const baseLabel =
        meta && meta.node && meta.node.label ? meta.node.label : "页面";
      const currentPageName = baseLabel + "copy";
      if (String(pageId) === String(this.selectedCurrentPage)) {
        this.flushCurrentPageToStore(pageId);
      }
      let all = parseCanvasAllData(this.canvasAllData);
      let data = JSON.parse(
        JSON.stringify(all[pageId] || this.componentData || [])
      );
      if (!data[0]) {
        data = [this.getPageData(pageId)];
      }
      if (!data[0].style) {
        data[0].style = {};
      }
      data[0].style.pageName = currentPageName;
      if (meta && meta.parent != null) {
        data[0].isChildPage = true;
        data[0].parentId = meta.parent.value;
      } else {
        delete data[0].isChildPage;
        delete data[0].parentId;
        if (data[0].style) {
          delete data[0].style.pageWidth;
          delete data[0].style.pageHeight;
        }
      }
      data = data.map((item) => this.regenerateComponentIds(item));
      return {
        id,
        data,
        meta,
        sourcePageId: pageId,
      };
    },
    copyPage(sourcePageId) {
      const { pages } =
        (atob(this.$route.query.limits) &&
          JSON.parse(atob(this.$route.query.limits))) ||
        {};
      if (this.countPageTree() >= pages * 1) {
        this.$message.error("不得超过页面最高限制个数");
        return;
      }
      const pageId =
        sourcePageId != null ? String(sourcePageId) : String(this.currentPage);
      const meta = this.findPageTreeNode(pageId);
      if (!meta || !meta.node) {
        this.$message.error("未找到页面，无法复制");
        return;
      }
      const runCopy = () => {
        const copyResult = this.copyPageData(pageId);
        const id = copyResult.id;
        const copyDatas = { id, data: copyResult.data };
        const currentPageName = copyDatas.data[0].style.pageName;
        const copyMeta = copyResult.meta || meta;

        this.flushCurrentPageToStore(this.selectedCurrentPage);
        let data = parseCanvasAllData(this.canvasAllData);
        data[id] = copyDatas.data;
        this.copyCanvasDatas = JSON.stringify(data);
        this.$store.commit("markCanvasPageLoaded", id);
        this.setCanvasCache(JSON.stringify(data));

        let errorData = JSON.parse(
          window.sessionStorage.getItem("canvasErrorMap") || "{}"
        );
        errorData[id] = {};
        sessionStorage.setItem("canvasErrorMap", JSON.stringify(errorData));
        this.$store.commit("setCurErrorMap");

        let styleData = JSON.parse(
          window.sessionStorage.getItem("canvasStyle") || "{}"
        );
        const sourceStyle = this.normalizeCanvasStyleEntry(
          styleData[copyResult.sourcePageId],
          this.$store.state.canvasStyleData
        );
        styleData[id] = JSON.parse(JSON.stringify(sourceStyle));
        sessionStorage.setItem("canvasStyle", JSON.stringify(styleData));

        const isCopyChild = copyMeta.parent != null;
        if (isCopyChild) {
          const newOptions = JSON.parse(JSON.stringify(this.pageOptions));
          const parentKey = copyMeta.parent.value;
          const pInd = newOptions.findIndex(
            (p) => String(p.value) === String(parentKey)
          );
          if (pInd === -1) {
            this.$message.error("父页面不存在，无法复制子页面");
            return;
          }
          if (!newOptions[pInd].children) {
            newOptions[pInd].children = [];
          }
          newOptions[pInd].children.push({
            label: currentPageName,
            value: id,
          });
          if (this.$refs.leftComp) {
            this.$refs.leftComp.addExpandedKey(parentKey);
          }
          this.$store.commit("setPageOptions", newOptions);
          this.$nextTick(() => {
            if (this.$refs.leftComp) {
              this.$refs.leftComp.expandTreeNodeByKey(parentKey);
            }
          });
        } else {
          this.page_sort.push(id);
          sessionStorage.setItem("pageSortData", JSON.stringify(this.page_sort));
          this.$store.commit("setPageOptions", [
            ...this.pageOptions,
            {
              label: currentPageName,
              value: id,
            },
          ]);
        }
        this.currentPage = String(id);
        const metaNew = this.findPageTreeNode(id);
        this.currentPageParent =
          metaNew && metaNew.parent != null ? metaNew.parent.value : null;
      };

      if (
        this.canvasLazyLoad &&
        String(pageId) !== String(this.selectedCurrentPage)
      ) {
        eventBus.$emit("ensureCanvasPages", {
          pageIds: [pageId],
          done: runCopy,
        });
        return;
      }
      runCopy();
    },
    deletePage(v, isChild) {
      var pages = [];
      const deletedParent = !isChild
        ? this.pageOptions.find((item) => String(item.value) === String(v))
        : null;
      if (isChild) {
        pages = this.pageOptions.reduce((arr, item) => {
          var obj = JSON.parse(JSON.stringify(item));
          if (item.children && item.children.length !== 0) {
            var newChildren = item.children.filter((child) => child.value != v);
            obj.children = newChildren;
          }
          arr.push(obj);
          return arr;
        }, []);
      } else {
        pages = this.pageOptions.filter((item) => item.value != v);
      }
      this.$store.commit("setPageOptions", pages);
      this.$delete(this.pagePanMap, this.viewportPageKey(v));
      if (deletedParent && deletedParent.children && deletedParent.children.length) {
        deletedParent.children.forEach((child) => {
          this.$delete(this.pagePanMap, this.viewportPageKey(child.value));
        });
      }
      if (String(this.currentPage) === String(v)) {
        // 删除的是当前页面（无需再缓存被删页的视口）
        this.currentPage = pages[0] != null ? String(pages[0].value) : this.currentPage;
      }
      // this.$refs.pageSelector.blur();
      //删除数据
      const data = parseCanvasAllData(this.canvasAllData);
      delete data[v];
      this.$store.commit("unmarkCanvasPageLoaded", v);
      if (deletedParent && deletedParent.children && deletedParent.children.length) {
        deletedParent.children.forEach((child) => {
          delete data[child.value];
          this.$store.commit("unmarkCanvasPageLoaded", child.value);
        });
      }
      this.setCanvasCache(JSON.stringify(data))

      let styledata = {};
      try {
        styledata = JSON.parse(window.sessionStorage.getItem("canvasStyle") || "{}") || {};
      } catch (e) {
        styledata = {};
      }
      delete styledata[v];
      sessionStorage.setItem("canvasStyle", JSON.stringify(styledata));
      if (!isChild) {
        const sortInd = this.page_sort.findIndex(
          (p) => String(p) === String(v)
        );
        if (sortInd !== -1) {
          this.page_sort.splice(sortInd, 1);
          sessionStorage.setItem("pageSortData", JSON.stringify(this.page_sort));
        }
      }

      this.resetErrorMap();
      this.$refs.leftComp.setTreeSelect();
    },
    resetErrorMap() {
      // ???
      const data = JSON.parse(window.sessionStorage.getItem("canvasErrorMap"));
      for (let key in data) {
        if (this.page_sort.indexOf(key) === -1 && this.page_sort.indexOf(Number(key)) === -1) {
          delete data[key];
        }
      }
      sessionStorage.setItem("canvasErrorMap", JSON.stringify(data));
      this.$store.commit("setCurErrorMap");
    }
  },
};
</script>

<style lang="scss" scoped>
.comp-panel {
  height: auto;
}
</style>
<style lang="scss">
@import url(../../assets/fonts/index.css);
@import url(../../assets/btnfont/wirdfont.css);
.home-container {
  overflow: hidden;
  height: 100%;
  .attr-error-tip {
    font-size: 13px;
    position: absolute;
    top: 100%;
    color: #f56c6c;
    font-weight: 700;
    left: 56px;
    right: 0px;
    white-space: normal;
    line-height: 1.3;
    z-index: 2;
  }
  .attr-has-error {
    background: #fff1f0;
    border: 1px solid #f56c6c;
    border-radius: 4px;
    padding: 8px 6px;
    animation: attr-error-pulse 1s ease 4;
  }
}
.home {
  height: 100%;
  background: #f0f2f5;
  min-width: 1170px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .comp-panel {
    background: #fff;
    border-bottom: 1px solid #e4e7ed;
    box-shadow: 0 1px 0 rgba(0, 21, 41, 0.04);
  }

  main {
    flex: 1;
    min-height: 0;
    position: relative;
    user-select: none; // 避免拖拽时选中
    .left {
      position: absolute;
      height: calc(100% - 16px);
      width: 274px;
      left: 8px;
      top: 8px;
      overflow: hidden;
      transition: width 0.2s ease, opacity 0.2s ease;
      background: #fff;
      border: 1px solid #ebeef5;
      border-radius: 8px;
      box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
      z-index: 8;
      .pageSelector {
        padding: 0 20px;
        display: flex;
        height: 36px;
        .el-input__inner {
          // height: 46px;
          width: 170px;
        }
        .sortBtn {
          background-color: #fdfeff;
          border: 1px solid #b8d6fc;
          color: #569ef8;
          padding: 7px 15px;
          margin-left: 10px;
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 3px;
          cursor: pointer;
          font-size: 15px;
          &:hover {
            background-color: #409eff;
            color: #fff !important;
          }
        }
      }
      .addPageBtn {
        height: 50px;
        margin: 20px auto 0px;
        font-size: 16px;
        background-color: #409eff;
        color: #fff;
        width: 250px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }

    .right {
      position: absolute;
      height: calc(100% - 16px);
      width: 324px;
      right: 8px;
      top: 8px;
      overflow-x: hidden;
      overflow-y: hidden;
      transition: width 0.2s ease, opacity 0.2s ease;
      background: #fff;
      border: 1px solid #ebeef5;
      border-radius: 8px;
      box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
      z-index: 8;
      .el-tabs__item {
        font-size: 12px;
        padding: 0 6px;
      }
      .el-tabs__header {
        margin: 0 0 4px;
        background: #fff;
      }
      .el-input__inner,
      .el-textarea__inner {
        border-radius: 6px;
        border-color: #e4e7ed;
      }
      .el-collapse-item__header {
        height: 32px;
        line-height: 32px;
        font-size: 12px;
      }
      .el-collapse-item__content {
        padding-bottom: 12px;
      }
      .attr-list {
        padding: 0 8px 16px;
        .info {
          margin: 12px 0;
        }
        .pos-grid .info {
          margin: 0;
        }
        .label {
          min-width: 52px;
          margin-right: 0;
        }
        .pos-grid .label {
          min-width: 0;
        }
      }
      .propertyItem {
        margin: 12px 0;
      }
      .placeholder {
        color: #909399;
        font-size: 13px;
        padding: 28px 12px;
      }
    }

    .center {
      margin-left: 0;
      margin-right: 0;
      background: #f0f2f5;
      height: 100%;
      overflow: hidden;
      position: relative;
      box-sizing: border-box;
      padding: 8px;
      .content {
        width: 100%;
        height: 100%;
        overflow: auto;
        position: relative;
        overflow: hidden; /* 禁止水平和垂直滚动 */
        border-radius: 8px;
        background: #c5cad3;
        box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
        &::-webkit-scrollbar {
          display: none;
        }
      }

      .canvas-error-banner {
        position: absolute;
        top: 12px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 20;
        max-width: 86%;
        padding: 10px 16px;
        border-radius: 6px;
        background: #fef0f0;
        border: 1px solid #f56c6c;
        color: #c45656;
        font-size: 14px;
        font-weight: 600;
        line-height: 1.45;
        box-shadow: 0 6px 18px rgba(245, 108, 108, 0.28);
        display: flex;
        align-items: flex-start;
        gap: 8px;
        pointer-events: none;
        i {
          margin-top: 2px;
        }
      }

      .panel-fold {
        position: absolute;
        top: 50%;
        z-index: 12;
        width: 16px;
        height: 56px;
        padding: 0;
        border: 1px solid #e4e7ed;
        background: #fff;
        color: #909399;
        cursor: pointer;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          color: #409eff;
          border-color: #c6e2ff;
          background: #ecf5ff;
        }
      }
      .panel-fold-left {
        left: 282px;
        transform: translateY(-50%);
        border-radius: 0 8px 8px 0;
        border-left: none;
        transition: left 0.2s ease;
      }
      .panel-fold-right {
        right: 332px;
        transform: translateY(-50%);
        border-radius: 8px 0 0 8px;
        border-right: none;
        transition: right 0.2s ease;
      }
    }
  }

  &.left-collapsed main .left {
    width: 0;
    opacity: 0;
    border: none;
    pointer-events: none;
  }
  &.left-collapsed main .center .panel-fold-left {
    left: 0;
  }
  &.right-collapsed main .right {
    width: 0;
    opacity: 0;
    border: none;
    pointer-events: none;
  }
  &.right-collapsed main .center .panel-fold-right {
    right: 0;
  }

  .placeholder {
    text-align: center;
    color: #909399;
  }
}
.pageItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@keyframes attr-error-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(245, 108, 108, 0.45);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(245, 108, 108, 0);
  }
}
</style>
